import { render, staticRenderFns } from "./propertyCreditScoreList.vue?vue&type=template&id=a690ecca&scoped=true&"
import script from "./propertyCreditScoreList.vue?vue&type=script&lang=js&"
export * from "./propertyCreditScoreList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a690ecca",
  null
  
)

export default component.exports